import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from './errors';
import { ManifestStore } from './manifestStore';
import { getElementManifestByInnerElementPath } from './utils/getElementManifestUtils';
import { getManifestValueHandlers } from './utils/getManifestValueHandlers';
export class ManifestServices {
  constructor(_ManifestUrlResolver) {
    _defineProperty(this, "_manifestStore", void 0);
    this._manifestStore = new ManifestStore(_ManifestUrlResolver);
    this.setManifest = this.setManifest.bind(this);
    this.getManifestsByCompTypes = this.getManifestsByCompTypes.bind(this);
  }
  getValueFromManifest(_ref, definition, property) {
    let {
      compType,
      innerElementPath
    } = _ref;
    const manifest = getElementManifestByInnerElementPath(this._manifestStore.getManifest(compType), innerElementPath);
    if (!manifest) {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ThereIsNoManifestForComp).withComponentType(compType).withInnerElementPath(innerElementPath);
    }
    return getManifestValueHandlers[definition]({
      property,
      manifest
    });
  }
  get manifestStore() {
    return this._manifestStore;
  }
  async loadManifestsByCompTypes(compTypes, hardUpdate) {
    if (hardUpdate === void 0) {
      hardUpdate = false;
    }
    return this._manifestStore.loadManifestsByCompTypes(compTypes, hardUpdate);
  }
  async loadAndResolveManifestsByCompTypes(compTypes) {
    const compTypesWithLoadedManifests = await this.loadManifestsByCompTypes(compTypes);
    return this.resolveManifestsByCompTypes(compTypesWithLoadedManifests);
  }
  async forceLoadAndResolveManifestsByCompTypes(compTypes) {
    const compTypesWithLoadedManifests = await this.loadManifestsByCompTypes(compTypes, true);
    return this.resolveManifestsByCompTypes(compTypesWithLoadedManifests);
  }
  async resolveManifestsByCompTypes(compTypes) {
    return this._manifestStore.resolveManifestsByCompTypes(compTypes);
  }
  getManifestsByCompTypes(compTypes) {
    return this._manifestStore.getManifestsByCompTypes(compTypes);
  }
  setManifest(compType, manifest) {
    this._manifestStore.setManifest(compType, manifest);
  }
  setInitialLoad(initialLoad) {
    this._manifestStore.setInitialLoad(initialLoad);
  }
}
//# sourceMappingURL=manifestServices.js.map